import { useMutation, useQueryClient } from "@tanstack/react-query";
import { reorderPage } from "../../services/page";

const useReorderPage = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: reorderPage,
        onSuccess: (status) => {
            if(status === 200) {
                queryClient.invalidateQueries({queryKey: ["questionnaire_content"]});
            }
        }, onError: (error) => { } 
    });
}

export default useReorderPage;